import config from "@/config/config";
import CryptoJS from "crypto-js";

//加密
export const encryptData = function (str) {
	//加密
	if (!str) return false;
	str = JSON.stringify(str);
	str = CryptoJS.enc.Utf8.parse(str);
	str = CryptoJS.enc.Base64.stringify(str);

	return str;
};

//解密
export const decryptData = function (str) {
	if (!str) return false;
	str = str.toString(CryptoJS.enc.Utf8);
	str = decodeURIComponent(str);
	str = CryptoJS.enc.Base64.parse(str);
	str = str.toString(CryptoJS.enc.Utf8);

	return str;
};

export const checkData = function (data, flag = null) {
	let res = {
		statusCode: data.statusCode,
		code: data.data.code,
		msg: data.data.msg,
	};
	if (parseInt(data.statusCode) == 200) {
		if (parseInt(data.data.code) == 1) {
			if (parseInt(config.cryptFlag) == 1) {
				res["data"] = decryptData(data.data.data);
			} else {
				res["data"] = data.data.data;
			}
		}
	}

	return res;
};

export const checkToken = function (obj) {
	let data = {};
	obj["cid"] = config.channelID;
	obj["siteCode"] = config.websiteTemplateCode;
	obj["sourceFlag"] = config.sourceFlag;
	obj["timestamp"] = Date.parse(new Date()) / 1000;
	obj["sign"] = getSign(obj);
	let token = encryptData(obj);
	data["token"] = token;
	data["cryptFlag"] = config.cryptFlag;

	return data;
};

export const getSign = function (obj) {
	if (!obj) return false;
	var sign = "";
	for (var i in obj) {
		sign += obj[i];
	}
	let encryptKey = config.encryptKey;

	return CryptoJS.MD5(sign + encryptKey).toString();
};
